export default __webpack_public_path__ + "static/media/up-arrow.1bdbef9c.svg";